import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl, isKeycloakIDP } from '../utils/loginProvider';
import { syncKeycloakAccessToken } from '../config/keycloak/Keycloak';
import {
   getAccessTokenLocalStorage
} from '../utils/token';

export const baseQuery = fetchBaseQuery({
   baseUrl: getApiBaseUrl(),
   prepareHeaders: (headers) => {
      const token = getAccessTokenLocalStorage();
      if (token) {
         headers.set('authorization', `Bearer ${token}`);
      }

      return headers;
   },
});
export const baseQueryWithRedirect: BaseQueryFn<
   string | FetchArgs,
   unknown,
   FetchBaseQueryError
> = async (args, api, extraOptions) => {
   if (isKeycloakIDP) {
      await syncKeycloakAccessToken(30);
   }

   const result = await baseQuery(args, api, extraOptions);
   if (result.error?.status === 401) {
      window.location.href = '/login';
   }

   return result;
};
